import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import SelectGroup from '../../../components/casino/SelectGroup';
import CusAutocomplete from '../../../components/material-ui/CusAutocomplete';
import CusDateTimePicker from '../../../components/material-ui/CusDateTimePicker';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import CusButton from '../../../components/material-ui/CusButton';
import { getOnlyData } from '../../../utils';
import dayjs from 'dayjs';
import { ENUM_DEPOSIT_STATUS, sourcePlatformOptions } from '../../../enums/enums';
import { useAppSelector } from '../../../store';
import { useTranslation } from 'react-i18next';
import UserAutoComplete from '../../../components/material-ui/userAutoComplete';
import DatePreset from '../../../components/material-ui/DatePreset';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import CurrencySelect, { ENUM_CURRENCY } from '../../../components/shared/CurrencySelect';

export default function PaymentFilter({
  onSaveClick,
  statusHash,
  updatePlayers,
  btnLoading,
  setPageNo
}) {
  const { t } = useTranslation();
  const mainGroup = useAppSelector((state) => state.user.group.main);
  const players = useAppSelector((state) => state.finance.payout.players);
  const payoutFilter = useAppSelector((state) => state.finance.payout.filter);

  const mainGroupId = mainGroup.groupId;

  const prevWeek = getOnlyData(dayjs().subtract(30, 'day'), '00:00:00');
  const today = getOnlyData(dayjs(), '23:59:59');
  const { isMobile } = useBootstrapSize();

  const [selectGroupId, setSelectGroupId] = useState(payoutFilter.groupId ?? mainGroupId);
  const [status, setStatus] = useState(payoutFilter.status ?? 0);
  const [source, setSource] = useState(payoutFilter.source ?? 'any');
  const [startDate, setStartDate] = useState(payoutFilter.dateFrom ?? prevWeek);
  const [endDate, setEndDate] = useState(payoutFilter.dateTo ?? today);
  const [selectPlayer, setSelectPlayer] = useState(payoutFilter.userId ?? 0);
  const [currency, setCurrency] = useState(payoutFilter.currency ?? ENUM_CURRENCY.all);

  const getLabelStatus = (el) => ENUM_DEPOSIT_STATUS[el] || el;

  const playersGroup = players[selectGroupId] || [];

  const playersOptions = playersGroup.map((el) => ({ label: el.login, value: el.id }));
  const statusesOptions = Object.keys(statusHash).map?.((id) => ({
    label: getLabelStatus(statusHash[id]),
    value: +id
  }));
  playersOptions.unshift({ label: t('All'), value: 0 });

  const gridSize = { xs: 12, sm: 6 };

  useEffect(() => {
    if (selectGroupId) return;
    console.log('selectGroupId', selectGroupId);

    setSelectGroupId(mainGroupId);
  }, [selectGroupId, mainGroupId]);

  useEffect(() => {
    if (!selectGroupId) return;
    updatePlayers(selectGroupId);
  }, [selectGroupId]);

  return (
    <>
      <Grid container rowSpacing={2} columnSpacing={1}>
        <Grid size={12}>
          <SelectGroup
            title="Group"
            hideTooltip
            selectGroupId={selectGroupId}
            setSelectGroupId={(val) => {
              setSelectPlayer(0);
              setSelectGroupId(val);
            }}
          />
        </Grid>
        <Grid size={gridSize}>
          <UserAutoComplete
            groupId={selectGroupId}
            options={playersOptions}
            userId={selectPlayer}
            setUserId={setSelectPlayer}
          />
        </Grid>
        <Grid size={gridSize}>
          <CurrencySelect value={currency} setValue={setCurrency} isChooseAll />
        </Grid>
        <Grid size={gridSize}>
          <CusDateTimePicker
            label="Start Date"
            value={startDate}
            onChange={setStartDate}
            formatChange="YYYY-MM-DD HH:mm:ss"
          />
        </Grid>
        <Grid size={gridSize}>
          <CusDateTimePicker
            label="End Date"
            value={endDate}
            onChange={setEndDate}
            formatChange="YYYY-MM-DD HH:mm:ss"
            errorText={
              startDate && endDate && new Date(endDate).getTime() <= new Date(startDate).getTime()
                ? t('End date must be later than start date')
                : ''
            }
          />
        </Grid>
        <Grid size={12} mt={-0.5}>
          <DatePreset
            fontSize={isMobile ? 12 : 14}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 4 }}>
          <CusLabelSelect
            label={'Invoice status'}
            value={status}
            options={statusesOptions}
            onChange={setStatus}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 4 }}>
          <CusLabelSelect
            label={'Pool'}
            value={source}
            options={sourcePlatformOptions}
            onChange={setSource}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} alignSelf={'end'}>
          <CusButton
            text="Show"
            variant="contained"
            fullWidth
            onClick={() =>
              onSaveClick({
                groupId: selectGroupId,
                userId: selectPlayer,
                dateFrom: startDate,
                dateTo: endDate,
                status: status,
                source: source,
                currency: currency
              })
            }
            disabled={!Object.keys(statusHash).length || btnLoading}
          />
        </Grid>
      </Grid>
    </>
  );
}
